import MobileStores from '../Common/Footer/MobileStores'
import Modal from '../Common/Modal'
import { StencilCDNImage } from '@/components/Common/StencilImage'

const AppOnlyFeature = ({
  showModal = false,
  onClose = () => {},
  title1,
  title2,
}: {
  showModal: boolean
  onClose: () => void
  title1?: string
  title2?: string
}) => (
  <Modal
    showModal={showModal}
    onClose={onClose}
    bodyClassName="max-w-[680px] h-[466px]"
  >
    <div className="flex h-full flex-col items-center justify-center p-5">
      <div className=" h-36 w-36 ">
        <StencilCDNImage
          src="https://indcdn.indmoney.com/public/images/qr/qr_indmoney.png"
          alt="Download INDmoney App by scanning the QR code"
          layout="responsive"
          width={144}
          height={144}
          quality={100}
        />
      </div>
      <div className="mt-8 text-lg font-medium">
        {title1 ?? ' This feature is only available on the INDmoney App'}
      </div>{' '}
      <div className="mb-4 text-sm font-normal lg:text-center lg:text-base">
        {title2 ?? 'Download it on your mobile device to continue'}
      </div>
      <MobileStores />
    </div>
  </Modal>
)

export default AppOnlyFeature
